import React, { useState } from "react";
import {
  Box, Card, CardContent, TextField, Button, Typography,
  Stack, Alert, InputAdornment, Link,
} from "@mui/material";
import { Email, CheckCircle, ArrowBack } from "@mui/icons-material";
import { alpha, useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_CLIENT_API_URL;

export default function ForgotPassword_View() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError("");
    if (!email.trim()) { setError("Inserisci la tua email"); return; }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/client/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const data = await res.json();
      if (res.ok) {
        setSent(true);
      } else {
        setError(data.error || "Errore nella richiesta");
      }
    } catch {
      setError("Impossibile connettersi al server. Riprova più tardi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
        p: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 420, borderRadius: 4, boxShadow: "0 24px 64px rgba(0,0,0,0.2)" }}>
        <CardContent sx={{ p: 4 }}>
          {sent ? (
            <Stack alignItems="center" spacing={2} textAlign="center">
              <CheckCircle sx={{ fontSize: 64, color: "success.main" }} />
              <Typography variant="h6" fontWeight={700}>Email inviata</Typography>
              <Typography variant="body2" color="text.secondary">
                Se l'indirizzo è registrato, riceverai a breve le istruzioni per reimpostare la password.
              </Typography>
              <Button variant="outlined" fullWidth startIcon={<ArrowBack />} onClick={() => navigate("/login")}>
                Torna al login
              </Button>
            </Stack>
          ) : (
            <>
              <Stack alignItems="center" spacing={1} mb={3}>
                <Email sx={{ fontSize: 40, color: "primary.main" }} />
                <Typography variant="h6" fontWeight={700}>Password dimenticata?</Typography>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                  Inserisci la tua email. Se è registrata, riceverai un link per reimpostare la password.
                </Typography>
              </Stack>

              <form onSubmit={handleSubmit}>
                <Stack spacing={2.5}>
                  {error && <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert>}

                  <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(""); }}
                    fullWidth
                    autoFocus
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email sx={{ color: "text.secondary" }} />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    size="large"
                    disabled={loading}
                    sx={{ py: 1.5, borderRadius: 2, fontWeight: 600 }}
                  >
                    {loading ? "Invio in corso..." : "Invia link di reset"}
                  </Button>

                  <Stack alignItems="center">
                    <Link
                      component="button"
                      variant="body2"
                      onClick={() => navigate("/login")}
                      underline="hover"
                      sx={{ color: "text.secondary" }}
                    >
                      <ArrowBack sx={{ fontSize: 14, mr: 0.5, verticalAlign: "middle" }} />
                      Torna al login
                    </Link>
                  </Stack>
                </Stack>
              </form>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
